/**
 * Hook to manage user settings
 * Now consumes from UserSettingsContext to ensure synchronized state
 */

import { useUserSettingsContext } from '../context/user-settings-context';
import { type User } from 'firebase/auth';

interface UseUserSettingsResult {
    settings: UserSettings | null;
    isLoading: boolean;
    needsOnboarding: boolean;
    refresh: () => Promise<void>;
}

/**
 * useUserSettings hook - consumes central context
 * The 'user' parameter is kept for backward compatibility but is managed by the context
 */
export function useUserSettings(_user?: User | undefined): UseUserSettingsResult {
    return useUserSettingsContext();
}

